import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { dashboardService } from '../../services/api'

const initialState = {
  analytics: {},
  caseStats: {},
  revenueStats: {},
  userStats: {},
  recentActivity: [],
  loading: false,
  error: null
}

export const fetchAnalytics = createAsyncThunk(
  'dashboard/fetchAnalytics',
  async (period = '30d', { rejectWithValue }) => {
    try {
      const response = await dashboardService.getAnalytics(period)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch analytics')
    }
  }
)

export const fetchCaseStats = createAsyncThunk(
  'dashboard/fetchCaseStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await dashboardService.getCaseStats()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch case stats')
    }
  }
)

export const fetchRevenueStats = createAsyncThunk(
  'dashboard/fetchRevenueStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await dashboardService.getRevenueStats()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch revenue stats')
    }
  }
)

export const fetchRecentActivity = createAsyncThunk(
  'dashboard/fetchRecentActivity',
  async (_, { rejectWithValue }) => {
    try {
      const response = await dashboardService.getRecentActivity()
      return response.data.activities
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch recent activity')
    }
  }
)

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalytics.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => {
        state.loading = false
        state.analytics = action.payload
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      .addCase(fetchCaseStats.fulfilled, (state, action) => {
        state.caseStats = action.payload
      })
      
      .addCase(fetchRevenueStats.fulfilled, (state, action) => {
        state.revenueStats = action.payload
      })
      
      .addCase(fetchRecentActivity.fulfilled, (state, action) => {
        state.recentActivity = action.payload
      })
  }
})

export const { clearError } = dashboardSlice.actions
export const selectAnalytics = (state) => state.dashboard.analytics
export const selectCaseStats = (state) => state.dashboard.caseStats
export const selectRevenueStats = (state) => state.dashboard.revenueStats
export const selectRecentActivity = (state) => state.dashboard.recentActivity
export const selectDashboardLoading = (state) => state.dashboard.loading
export const selectDashboardError = (state) => state.dashboard.error

export default dashboardSlice.reducer 